import { render, staticRenderFns } from "./FeverPrivacy.vue?vue&type=template&id=bc15645e&scoped=true"
import script from "./FeverPrivacy.vue?vue&type=script&lang=js"
export * from "./FeverPrivacy.vue?vue&type=script&lang=js"
import style0 from "./FeverPrivacy.vue?vue&type=style&index=0&id=bc15645e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc15645e",
  null
  
)

export default component.exports